<span>{{serviceType[data[fieldName]]}}</span>
